import client from "../client/client";

class RedressmentService {
	redress({ docId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}`, { payload, config: { cancelToken } });
	}

	move({ docId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/move`, { payload, config: { cancelToken } });
	}

	group({ docId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/group`, { payload, config: { cancelToken } });
	}

	split({ docId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/split`, { payload, config: { cancelToken } });
	}

	delete({ docId, contentId }, cancelToken) {
		return client.delete(`/redressment/documents/${docId}/content/${contentId}/delete`, {
			config: { cancelToken },
		});
	}

	previewRedressInfo({ docId, infoId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/information/${infoId}/crop`, {
			payload,
			config: { cancelToken },
		});
	}

	proceedRedressInfo({ docId, infoId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/information/${infoId}/proceed`, {
			payload,
			config: { cancelToken },
		});
	}

	compute({ docId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/requirements/compute`, {
			payload,
			config: { cancelToken },
		});
	}

	clearRequirements({ docId }, payload, cancelToken) {
		return client.post(`/redressment/documents/${docId}/requirements/clear`, { payload, config: { cancelToken } });
	}

	extractOcrText({ docId }, { pageId, x1, x2, y1, y2 }, cancelToken) {
		return client.post(`/redressment/documents/${docId}/information/extractText`, {
			payload: { pageId, x1, x2, y1, y2 },
			config: { cancelToken },
		});
	}

	addNewInformationContent({ docId }, { reqRecPosDto, previousId, text }, cancelToken) {
		return client.post(`/redressment/documents/${docId}/information/addInformation`, {
			payload: { reqRecPosDto, previousId, text },
			config: { cancelToken },
		});
	}

	swapContentOrder({ docId }, { contentId1, contentId2 }, cancelToken) {
		return client.patch(`/redressment/documents/${docId}/content/order/swap`, {
			payload: { contentId1, contentId2 },
			config: { cancelToken },
		});
	}
}

export default new RedressmentService();
